import api from './api';

export interface ChatConversa {
  id: string;
  tipo: 'direto' | 'grupo';
  nome?: string;
  criador_id?: string;
  data_criacao: string;
  data_ultima_mensagem?: string;
  total_mensagens: number;
  ultima_mensagem?: string;
  ultimo_remetente?: string;
  nao_lidas: number;
  membros: { id: string; nome: string; avatar?: string; ultima_leitura?: string }[];
}

export interface ChatMensagem {
  id: string;
  conversa_id: string;
  remetente_id: string;
  remetente_nome: string;
  remetente_avatar?: string;
  conteudo?: string;
  tipo: 'texto' | 'anexo' | 'sistema';
  data_criacao: string;
  anexos?: { id: string; nome_original: string; url: string; tipo: string; tamanho: number }[];
}

const chatInternoService = {
  listarConversas: async (): Promise<ChatConversa[]> => {
    const res = await api.get('/chat-interno/conversas');
    return res.data.conversas || [];
  },

  criarConversa: async (dados: { tipo: 'direto' | 'grupo'; nome?: string; membros: string[] }) => {
    const res = await api.post('/chat-interno/conversas', dados);
    return res.data;
  },

  buscarMensagens: async (conversaId: string): Promise<ChatMensagem[]> => {
    const res = await api.get(`/chat-interno/conversas/${conversaId}/mensagens?_t=${Date.now()}`);
    return res.data.mensagens || [];
  },

  enviarMensagem: async (conversaId: string, conteudo: string, arquivo?: File): Promise<ChatMensagem> => {
    if (arquivo) {
      const formData = new FormData();
      if (conteudo) formData.append('conteudo', conteudo);
      formData.append('arquivo', arquivo);
      const res = await api.post(`/chat-interno/conversas/${conversaId}/mensagens`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      return res.data.mensagem;
    }
    const res = await api.post(`/chat-interno/conversas/${conversaId}/mensagens`, { conteudo });
    return res.data.mensagem;
  },

  marcarComoLido: async (conversaId: string) => {
    await api.put(`/chat-interno/conversas/${conversaId}/leitura`);
  },

  totalNaoLidas: async (): Promise<number> => {
    const res = await api.get('/chat-interno/nao-lidas');
    return res.data.total || 0;
  },

  polling: async (desde: string): Promise<ChatMensagem[]> => {
    const res = await api.get(`/chat-interno/polling?desde=${encodeURIComponent(desde)}`);
    return res.data.mensagens || [];
  },

  apagarMensagem: async (mensagemId: string) => {
    await api.delete(`/chat-interno/mensagens/${mensagemId}`);
  },

  excluirConversa: async (conversaId: string) => {
    await api.delete(`/chat-interno/conversas/${conversaId}`);
  },

  downloadAnexo: async (anexoId: string): Promise<{ url: string }> => {
    const res = await api.get(`/chat-interno/anexos/${anexoId}/download`);
    return res.data;
  },

  adicionarMembro: async (conversaId: string, usuarioId: string) => {
    await api.post(`/chat-interno/conversas/${conversaId}/membros`, { usuario_id: usuarioId });
  },

  heartbeat: async () => {
    await api.post('/chat-interno/heartbeat');
  },

  obterOnline: async (): Promise<string[]> => {
    const res = await api.get('/chat-interno/online');
    return res.data.online || [];
  },
};

export default chatInternoService;
